import '../css/app.css'
import './bootstrap'
import './echo'

import AppLayout from '@/layouts/AppLayout.vue'
import { createInertiaApp, Head, Link, usePage } from '@inertiajs/vue3'
import { configureEcho } from '@laravel/echo-vue'
import Aura from '@primeuix/themes/aura'
import { definePreset } from '@primevue/themes'
// import * as Sentry from '@sentry/vue'
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers'
import PrimeVue from 'primevue/config'
import { createApp, h } from 'vue'
import { ZiggyVue } from 'ziggy-js'

configureEcho({
    broadcaster: 'reverb',
})

const MyPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '{green.50}',
            100: '{green.100}',
            200: '{green.200}',
            300: '{green.300}',
            400: '{green.400}',
            500: '{green.500}',
            600: '{green.600}',
            700: '{green.700}',
            800: '{green.800}',
            900: '{green.900}',
            950: '{green.950}',
        },
    },
})

const appName = import.meta.env.VITE_APP_NAME || 'Půjčovna'

createInertiaApp({
    defaults: {
        future: {
            useDialogForErrorModal: true,
        },
    },
    title: (title) => (title ? `${title}` + ' | ' + appName : appName),
    resolve: async (name) => {
        const page = await resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue'))

        const isAuthPage = name.startsWith('Auth/')
        const isErrorPage = name === 'Error'
        const hasErrorStatus = !!usePage().props?.status

        if (isAuthPage || isErrorPage || hasErrorStatus) {
            page.default.layout = null
        } else {
            page.default.layout = AppLayout
        }

        return page
    },
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue)
            .use(PrimeVue, {
                zIndex: {
                    modal: 1000,
                    overlay: 1000,
                    tooltip: 1000,
                },
                theme: {
                    preset: MyPreset,
                    options: {
                        cssLayer: {
                            name: 'primevue',
                            order: 'theme, base, primevue',
                        },
                        darkModeSelector: 'light',
                    },
                },
                locale: {
                    dayNames: ['Neděle', 'Pondělí', 'Úterý', 'Středa', 'Čtvrtek', 'Pátek', 'Sobota'],
                    dayNamesShort: ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'],
                    dayNamesMin: ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'],
                    monthNames: [
                        'Leden',
                        'Únor',
                        'Březen',
                        'Duben',
                        'Květen',
                        'Červen',
                        'Červenec',
                        'Srpen',
                        'Září',
                        'Říjen',
                        'Listopad',
                        'Prosinec',
                    ],
                    monthNamesShort: [
                        'Led',
                        'Úno',
                        'Bře',
                        'Dub',
                        'Kvě',
                        'Čer',
                        'Črc',
                        'Srp',
                        'Zář',
                        'Říj',
                        'Lis',
                        'Pro',
                    ],
                    today: 'Dnes',
                    clear: 'Vymazat',
                    weekHeader: 'Týden',
                    firstDayOfWeek: 1,
                },
            })
            .component('Head', Head)
            .component('Link', Link)
            .component('AppLayout', AppLayout)

        // Sentry.init({
        //     app,
        //     dsn: import.meta.env.VITE_SENTRY_DSN,
        //     tracesSampleRate: 1.0,
        //     environment: import.meta.env.VITE_APP_ENV,
        // })

        return app.mount(el)
    },
    progress: {
        color: '#4B5563',
    },
})
